import {MIP_SOURCE} from '@domain/pom'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ActionItem} from '../../types'

import {ActionDetailsSection} from './ActionDetailsSection'

type MipDetailsSectionProps = {
  action: ActionItem
}

/** the element only belongs to MIP actions, and only once one has been chosen */
export const hasMipElement = ({source, element}: ActionItem): boolean =>
  source === MIP_SOURCE && Boolean(element)

export const MipDetailsSection: FC<MipDetailsSectionProps> = ({action}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  if (!hasMipElement(action)) return null

  return (
    <ActionDetailsSection
      title={t('actionDetails.mipElement')}
      data-test-id="action-details-mip-element"
      value={t(`mipElement.${action.element}`)}
    />
  )
}
